var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: left;\n  color: #2f3946;\n  margin-bottom: 12px;\n  label {\n    font-weight: 600;\n  }\n'], ['\n  text-align: left;\n  color: #2f3946;\n  margin-bottom: 12px;\n  label {\n    font-weight: 600;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 0px;\n  margin-bottom: 0px;\n'], ['\n  margin-top: 0px;\n  margin-bottom: 0px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  margin-bottom: 8px;\n'], ['\n  color: ', ';\n  margin-bottom: 8px;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: inline;\n  position: fixed;\n  bottom: ', ';\n  right: ', ';\n  z-index: 2000;\n  @media (max-width: 768px) {\n    bottom: auto;\n    right: ', ';\n    top: ', ';\n  }\n  opacity: 0;\n  transition: all 0.25s ease-in-out;\n  opacity: ', ';\n'], ['\n  display: inline;\n  position: fixed;\n  bottom: ', ';\n  right: ', ';\n  z-index: 2000;\n  @media (max-width: 768px) {\n    bottom: auto;\n    right: ', ';\n    top: ', ';\n  }\n  opacity: 0;\n  transition: all 0.25s ease-in-out;\n  opacity: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: 13px;\n  line-height: 25px;\n  margin-bottom: 0px;\n  color: ', ';\n'], ['\n  font-size: 13px;\n  line-height: 25px;\n  margin-bottom: 0px;\n  color: ', ';\n']);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import { isNil, isEmpty } from 'ramda';
import Spinner from '../Spinner';
import Errors from '../Errors';
import Label from '../Label';
var FieldContainer = styled.div(_templateObject);
var ChildContainer = styled.div(_templateObject2);
var Hint = styled.p(_templateObject3, function (props) {
  return props.theme.colours.neutral.darkest;
});
var LoadingContainer = styled.div(_templateObject4, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.spaces.tight;
}, function (props) {
  return props.theme.spaces.tight;
}, function (props) {
  return props.loading;
});

var Loading = function Loading(props) {
  return React.createElement(LoadingContainer, {
    loading: props.loading
  }, React.createElement(Spinner, {
    width: '15px'
  }));
};

var Nudge = styled.div(_templateObject5, function (props) {
  return props.theme.colours.neutral.darker;
});

var Field = function (_Component) {
  _inherits(Field, _Component);

  function Field() {
    _classCallCheck(this, Field);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Field.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        hint = _props.hint,
        nudge = _props.nudge,
        errors = _props.errors,
        alignment = _props.alignment,
        isLoading = _props.isLoading,
        children = _props.children,
        dontUseContainer = _props.dontUseContainer,
        dark = _props.dark,
        light = _props.light,
        fieldClass = _props.fieldClass,
        rest = _objectWithoutProperties(_props, ['label', 'hint', 'nudge', 'errors', 'alignment', 'isLoading', 'children', 'dontUseContainer', 'dark', 'light', 'fieldClass']);

    var showHint = !isEmpty(hint) && !isNil(hint);
    var showErrors = errors === undefined ? false : true;
    var showLoading = isLoading === true ? 1 : 0;
    var formHint = showHint ? hint : '\xA0';
    var hasLabel = label ? true : false;
    return React.createElement(FieldContainer, _extends({
      className: dontUseContainer ? '' : 'a-field-container'
    }, rest), React.createElement(Loading, {
      loading: showLoading
    }), React.createElement('div', {
      className: dontUseContainer ? '' : fieldClass + ' a-field'
    }, hasLabel && React.createElement(Label, {
      dark: dark,
      light: light
    }, label), showHint && React.createElement(Hint, null, hint), React.createElement(ChildContainer, null, children), !showErrors && React.createElement(Nudge, null, nudge), showErrors && React.createElement(Errors, {
      errors: errors
    })));
  };

  return Field;
}(Component);

export default Field;